import { formatDilution, normalizeString } from "./format.utils";
function sortNumber(rowA, rowB, columnId, desc) {
    columnId = columnId.includes('validation') ? columnId.replace('validation', 'sensibility') : columnId;
    // Helper function to check if a value is a valid number
    const isValidNumber = (value) => {
        return value !== null && value !== undefined && value !== '' && value !== '-' && !isNaN(parseFloat(value)) && isFinite(value);
    };

    if (columnId.includes('.')) {
        // If columnId contains a dot, it means we need to access a nested property
        // Example: columnId = 'user.firstname' => ParentProperty = 'user', ChildProperty = 'firstname' 
        const columnIdParts = columnId.split('.');
        const property = columnIdParts[0]
        const value = columnIdParts[1]
        const valueA = rowA[property][value];
        const valueB = rowB[property][value];

        // Check if both values are valid numbers
        const isValueANumber = isValidNumber(valueA);
        const isValueBNumber = isValidNumber(valueB);

        // If both are numbers, sort normally
        if (isValueANumber && isValueBNumber) {
            return !desc ? valueA - valueB : valueB - valueA;
        }

        // If only one is a number, the number comes first, "-" always at the end
        if (isValueANumber && !isValueBNumber) {
            return -1; // Number always comes first
        }
        if (!isValueANumber && isValueBNumber) {
            return 1; // "-" always comes last
        }

        // If neither is a number, maintain original order
        return 0;
    }

    const valueA = rowA[columnId];
    const valueB = rowB[columnId];

    // Check if both values are valid numbers
    const isValueANumber = isValidNumber(valueA);
    const isValueBNumber = isValidNumber(valueB);

    // If both are numbers, sort normally
    if (isValueANumber && isValueBNumber) {
        return !desc ? valueA - valueB : valueB - valueA;
    }

    // If only one is a number, the number comes first, "-" always at the end
    if (isValueANumber && !isValueBNumber) {
        return -1; // Number always comes first
    }
    if (!isValueANumber && isValueBNumber) {
        return 1; // "-" always comes last
    }

    // If neither is a number, maintain original order
    return 0;
}

function sortDate(rowA, rowB, columnId, desc) {
    const valueA = new Date(rowA[columnId]);
    const valueB = new Date(rowB[columnId]);
    return !desc ? valueA - valueB : valueB - valueA;
}

const sortDilutions = (rowA, rowB, _columnId, desc) => {
    const valueA = formatDilution(rowA[_columnId]);
    const valueB = formatDilution(rowB[_columnId]);
    return !desc ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
}

const sortNestedText = (rowA, rowB, property, value, desc) => {
    const valueA = rowA[property] ? normalizeString(rowA[property][value]) : '';
    const valueB = rowB[property] ? normalizeString(rowB[property][value]) : '';

    if (valueA < valueB) {
        return !desc ? -1 : 1;
    }
    if (valueA > valueB) {
        return !desc ? 1 : -1;
    }
    return 0;
};

const sortNestedTextArray = (rowA, rowB, property, value, desc) => {

    const valueA = rowA[property].map(o => normalizeString(o)).join(' ');
    const valueB = rowB[property].map(o => normalizeString(o)).join(' ');
    if (valueA < valueB) {
        return !desc ? -1 : 1;
    }
    if (valueA > valueB) {
        return !desc ? 1 : -1;
    }
    return 0;
}



function sortText(rowA, rowB, columnId, desc) {
    if (columnId.includes('.')) {
        // If columnId contains a dot, it means we need to access a nested property
        // Example: columnId = 'user.firstname' => ParentProperty = 'user', ChildProperty = 'firstname' 
        const columnIdParts = columnId.split('.');
        const property = columnIdParts[0]
        const value = columnIdParts[1]
        const isArray = Array.isArray(rowA[property])
        if (isArray) {
            return sortNestedTextArray(rowA, rowB, property, value, desc);
        }
        return sortNestedText(rowA, rowB, property, value, desc);

    }
    const valueA = normalizeString(rowA[columnId]);
    const valueB = normalizeString(rowB[columnId]);

    if (valueA < valueB) {
        return !desc ? -1 : 1;
    }
    if (valueA > valueB) {
        return !desc ? 1 : -1;
    }
    return 0;
}

const sortStatus = (rowA, rowB, _columnId, desc) => {
    const statusA = rowA[_columnId];
    const statusB = rowB[_columnId];
    const statusOrder = ['processing', 'completed', 'expedie', 'livre', 'canceled', 'trash', null];
    if (desc) {
        statusOrder.pop()
        statusOrder.reverse().push(null);
        return statusOrder.indexOf(statusA) - statusOrder.indexOf(statusB);
    } else {
        return statusOrder.indexOf(statusA) - statusOrder.indexOf(statusB);
    }

}

const sortCombinedName = (rowA, rowB, _columnId, desc) => {
    // La valeur que l'on veut sort est une combinaison de row.firstname et row.lastname
    // On doit donc la créer en combinant les deux valeurs
    const valueA = normalizeString(`${rowA.firstname} ${rowA.lastname}`);
    const valueB = normalizeString(`${rowB.firstname} ${rowB.lastname}`);

    // On peut ensuite comparer les deux valeurs comme on le ferait pour un tri de texte
    if (valueA < valueB) {
        return !desc ? -1 : 1;
    }
    if (valueA > valueB) {
        return !desc ? 1 : -1;
    }
    return 0;

}

function sortSubCategory(rowA, rowB, columnId, desc) {
    if (columnId.includes('.')) {
        // If columnId contains a dot, it means we need to access a nested property
        // Example: columnId = 'user.firstname' => ParentProperty = 'user', ChildProperty = 'firstname' 
        const columnIdParts = columnId.split('.');
        const property = columnIdParts[0]
        const value = columnIdParts[1]
        const isArray = Array.isArray(rowA[property])
        if (isArray) {
            return sortNestedTextArray(rowA, rowB, property, value, desc);
        }
        return sortNestedText(rowA, rowB, property, value, desc);
    }

    const valueA = rowA[columnId];
    const valueB = rowB[columnId];

    // Ensure "Emotions" is always first
    if (valueA === "Emotions") return !desc ? -1 : 1;
    if (valueB === "Emotions") return !desc ? 1 : -1;

    // Helper function to extract category and number from ref
    const parseRef = (ref) => {
        if (!ref) return { category: '', number: 0 };
        const match = ref.match(/^([A-Z])(\d+)$/);
        if (match) {
            return { category: match[1], number: parseInt(match[2], 10) };
        }
        return { category: ref, number: 0 };
    };

    // Parse both values
    const parsedA = parseRef(valueA);
    const parsedB = parseRef(valueB);
    // If both are refs with category and number
    if (parsedA.category && parsedB.category && parsedA.number && parsedB.number) {
        // Same category: sort by number
        if (parsedA.category === parsedB.category) {
            const result = parsedA.number - parsedB.number;
            return !desc ? result : -result;
        }
        // Different categories: sort by category (E first, then C, then F)
        const categoryOrder = { 'E': 1, 'C': 2, 'F': 3 };
        const result = categoryOrder[parsedA.category] - categoryOrder[parsedB.category];
        return !desc ? result : -result;
    }

    // Fallback to string comparison for non-ref values
    if (valueA < valueB) {
        return !desc ? -1 : 1;
    }
    if (valueA > valueB) {
        return !desc ? 1 : -1;
    }
    return 0;
}

const CATEGORIES = ['Physique', 'Effluences']

const sortCategory = (rowA, rowB, _columnId, desc) => {
    const valueA = rowA.mixture.category;
    const valueB = rowB.mixture.category;
    return !desc ? CATEGORIES.indexOf(valueA) - CATEGORIES.indexOf(valueB) : CATEGORIES.indexOf(valueB) - CATEGORIES.indexOf(valueA);
}

export default { sortText, sortNumber, sortDate, sortStatus, sortDilutions, sortCombinedName, sortNestedTextArray, sortSubCategory, sortCategory };
